<template>
  <div id="menus"
       :class="['ipub-shadow', show?'menus--show':'']">
    <div class="menus__logo">
      <img :src="`${domain}/${publisherInfo.logo}`"
           alt="">
    </div>
    <div class="menus-content">
      <div v-for="(item, index) in menus"
           class=" mar-b-12 menus-content-item"
           :key="'menus'+index">
        <div v-if="user.codeList&&user.codeList.includes(item.code)||!item.code"
             :key="'menus-aside'+index"
             class="menus-aside-content">
          <template v-if="item.children && item.children.length">
            <div class="menus-aside__list">
              <div class="ipub-h3 mar-b-10">
                <div class="menus-aside__title">
                  <!-- <a @click="goToPage(item.redirect || item.href)"> -->
                  <font style="font-weight:400">
                    <ipub-icon :type="item.icon" />
                  </font>
                  {{item.enName}}
                  <!-- </a> -->
                </div>
              </div>
              <ipub-menus v-if="item.children && item.children.length">
                <template v-for="(val, num) in item.children">
                  <template v-if="(!val.$role || user.roles.includes(val.$role))&&(!val.$unrole || !user.roles.includes(val.$unrole))">
                    <div v-if="val.code&&user.codeList&&user.codeList.includes(val.code)||!val.code"
                         :class="['ipub-p2', 'menus-aside-item', path.includes(val.href)?'active':'']"
                         :key="'menus-aside-item'+num">
                      <div style="padding: 5px 0 5px 0;">
                        <a @click="goToPage(val.redirect || val.href)">{{val.enName}}</a>
                      </div>
                    </div>
                  </template>
                </template>
              </ipub-menus>
              <div v-if="item.children && item.children.length"
                   class="mar-b-10"></div>
            </div>
          </template>
          <template v-else>
            <div class="menus-aside__list">
              <div class="ipub-h3 menus-aside__title mar-b-10">
                <a @click="goToPage(item.redirect || item.href)">
                  <font style="font-weight:400">
                    <ipub-icon :type="item.icon" />
                  </font>
                  {{item.enName}}
                </a>
              </div>
            </div>
          </template>
        </div>
        <div class="split"
             v-if="user.codeList&&user.codeList.includes(item.code)||!item.code"></div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import menus from '../utils/menus'

export default {
  props: {
    show: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      menus,
      path: ''
    }
  },
  computed: {
    ...mapGetters({
      user: 'getUser',
      showMenus: 'getShowMenus',
      publisherInfo: 'getPublisherInfo',
      domain: 'getDomain'
    })
  },
  watch: {
    //监听相同路由下参数变化的时候，从而实现异步刷新
    $route () {
      this.path = this.$route.path
    },
  },
  mounted () {
    this.path = this.$route.path
  },
  methods: {
    goToPage (val) {
      if (this.user.completed) {
        if (!val.includes(this.$route.path)) {
          this.$router.push(val)
        }
      } else {
        this.$message.error({
          title: 'Error',
          content: 'Please complete your personal information first'
        })
        this.$router.push('/user-manage/profile')
      }
    },
  }
}
</script>

<style lang="scss" scoped>
#menus {
  position: fixed;
  top: 0;
  left: -100%;
  background: rgb(255, 255, 255);
  box-sizing: border-box;
  overflow-y: scroll;
  height: 100%;
  z-index: 998;
  transition: 0.3s all;
  .menus-content {
    // padding: 10px 30px;
    padding: 10px 0;
    &-item {
      &:nth-last-child(1) {
        .split {
          background: transparent;
        }
      }
    }
  }
  &.menus--show {
    left: 0px;
  }
  .menus__logo {
    height: 60px;
    color: #fff;
    font-size: 50px;
    display: flex;
    align-items: center;
    justify-content: center;
    > img {
      height: 56px;
      // filter: brightness(0) invert(1);
    }
  }
  .ipub-h4 {
    font-weight: normal;
  }
  .menus-aside-item {
    padding-left: 62px;
    font-size: 16px;

    transition: 0.3s all;
    position: relative;
    ::before {
      // content: '>';
      position: absolute;
      transition: 0.3s all;
      left: -16px;
    }
    &:hover,
    &.active {
      background: rgba($link_color, 0.2);
      ::before {
        background: rgba($link_color, 0.2);
        margin-left: 30px;
      }
    }
  }
  .menus-aside__title {
    transition: all 0.3s;
    font-size: 20px;
    font-weight: 700;
    padding-left: 30px;
    padding-right: 30px;
  }
  .menus-aside-content {
    &:last-child {
      border-bottom: none;
    }
    .menus-aside__warp {
      transition: all 0.3s;
      max-height: 0;
      overflow: hidden;
    }
    &.menus-aside--open,
    &:hover {
      .menus-aside__warp {
        max-height: 300px !important;
      }
    }
  }
}
.split {
  width: 229px;
  height: 1px;
  background: #d2d1d9;
  margin: 0 auto;
}
</style>
